export const CUSTOMIZE_TOUR_PATH = "/web/customize-tour";

export interface CustomizeTourParams {
  tourCode?: string;
  destination?: string;
  departDate?: string;
}

export function customizeTourHref({ tourCode, destination, departDate }: CustomizeTourParams): string {
  const params = new URLSearchParams();
  if (tourCode) params.set("tour_code", tourCode);
  if (destination) params.set("destination", destination);
  if (departDate) params.set("departure_date", departDate);

  const query = params.toString();
  return query ? `${CUSTOMIZE_TOUR_PATH}?${query}` : CUSTOMIZE_TOUR_PATH;
}
